module.exports = __webpack_public_path__ + "img/ms_my.44457b44.png";